import React, { useState, useEffect } from 'react';

import { APIROOT } from '../../Helpers/configs';

import { convertDate } from '../../Helpers/helpers';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

const TechItemHistory = (props) => {
  const serialNumber = props.serialNumber;
  const serialId = props.serialId;

  const [history, setHistory] = useState([]);

  useEffect(() => {
    const data = fetchHistory(serialId, setHistory);
    data === undefined ? setHistory([]) : setHistory(data);
  }, [serialId]);

  return (
    <TableContainer style={{ background: '#none' }}>
      <Table
        sx={{ minWidth: 650 }}
        size='small'
        aria-label='a dense table'
        style={{ background: '#none' }}
      >
        <TableHead>
          <TableRow style={{ background: '#none' }}>
            <TableCell>
              {' '}
              {`${history.length < 1 ? 'No  Previous History' : 'Date'}`}
            </TableCell>
            <TableCell>
              {' '}
              {`${history.length < 1 ? '' : 'Repair Details'}`}{' '}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{ background: '#none' }}>
          {
            // .slice(start, end) will map last 5 records only
            history.slice(0, 4).map((row) => (
              <TableRow
                key={row.id}
                sx={{
                  '&:last-child td, &:last-child th': {
                    border: 0,
                  },
                }}
              >
                <TableCell component='th' scope='row'>
                  {convertDate(row.ticket_date, 0, 10)}
                </TableCell>
                <TableCell>{row.description}</TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TechItemHistory;

function fetchHistory(serialID, setDataFunc) {
  //Get JWT from storage

  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(
    `${APIROOT}/api/serialnumberhistory/${serialID}`,
    { method: 'POST', headers: headers }
  );

  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setDataFunc(parsed.data.value);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
